import React, { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { SliderData } from "../../fakeData/Slider";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSettings } from "../../context/SettingsContext";
import imgUrl from "../../imgUrl";

function Slider() {
  const { t, i18n } = useTranslation();
  const settings = useSettings();
  const isBn = i18n.language === "bn";

  const slides = useMemo(() => {
    return [
      {
        name: isBn 
          ? (settings.slider_1_title_bn || "সেরা মানের পণ্য গ্যারান্টিড!") 
          : (settings.slider_1_title_en || "The Best Quality Products Guaranteed!"),
        description: isBn 
          ? (settings.slider_1_desc_bn || "সহজেই সকল পণ্যের সংযোগ এবং সেরা কেনাকাটা প্রক্রিয়া সুবিধা প্রদান করি") 
          : (settings.slider_1_desc_en || "Dramatically facilitate effective total linkage for go forward processes"),
        img: settings.slider_1_image 
          ? `${imgUrl}/${settings.slider_1_image}` 
          : SliderData[0].img,
        path: settings.slider_1_path || "biscuits--cakes"
      },
      {
        name: isBn 
          ? (settings.slider_2_title_bn || "সেরা ভিন্ন ধরণের মুদি দোকান") 
          : (settings.slider_2_title_en || "Best Different Type of Grocery Store"),
        description: isBn 
          ? (settings.slider_2_desc_bn || "গ্রাহকদের জন্য সেরা ও বৈচিত্র্যময় নিত্যপ্রয়োজনীয় সামগ্রী সরবরাহ করি") 
          : (settings.slider_2_desc_en || "Quickly aggregate empowered networks after emerging products"),
        img: settings.slider_2_image 
          ? `${imgUrl}/${settings.slider_2_image}` 
          : SliderData[1].img,
        path: settings.slider_2_path || "fish--meat"
      },
      {
        name: isBn 
          ? (settings.slider_3_title_bn || "মানসম্পন্ন সতেজতার নিশ্চয়তা!") 
          : (settings.slider_3_title_en || "Quality Freshness Guaranteed!"),
        description: isBn 
          ? (settings.slider_3_desc_bn || "সরাসরি মাঠ থেকে বাছাইকৃত একদম তাজা শাকসবজি ও ফলমূল") 
          : (settings.slider_3_desc_en || "Intrinsicly fashion performance based products rather than accurate benefits"),
        img: settings.slider_3_image 
          ? `${imgUrl}/${settings.slider_3_image}` 
          : SliderData[2].img,
        path: settings.slider_3_path || "fresh-vegetable"
      }
    ];
  }, [settings, isBn]);

  return (
    <Swiper
      spaceBetween={30}
      loop={true}
      centeredSlides={true}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      modules={[Autoplay, Pagination]}
      className="mySwiper"
    >
      {slides.map((data, index) => {
        return (
          <SwiperSlide
            key={index}
            className="rounded-lg relative h-full overflow-hidden"
          >
            <div className="text-sm text-gray-600 hover:text-emerald-dark">
              <span
                style={{
                  boxSizing: " border-box",
                  display: "block",
                  overflow: "hidden",
                  width: "initial",
                  height: "initial",
                  background: "none",
                  opacity: "1",
                  border: " 0px",
                  margin: "0px",
                  padding: "0px",
                  position: " relative",
                }}
              >
                <span
                  style={{
                    boxSizing: " border-box",
                    display: "block",
                    width: "initial",
                    height: "initial",
                    background: "none",
                    opacity: " 1",
                    border: "0px",
                    margin: "0px",
                    padding: "25% 0px 0px",
                  }}
                ></span>
                <img
                  alt="Quality Freshness Guaranteed!"
                  sizes="100vw"
                  src={data.img}
                  decoding="async"
                  data-nimg="responsive"
                  className="object-cover"
                  style={{
                    position: "absolute",
                    inset: "0px",
                    boxSizing: " border-box",
                    padding: "0px",
                    border: "none",
                    margin: "auto",
                    display: "block",
                    width: "0px",
                    height: " 0px",
                    minWidth: "100%",
                    maxWidth: "100%",
                    minHeight: "100%",
                    maxHeight: "100%",
                  }}
                />
              </span>
            </div>
            <div className="absolute top-0 left-0 z-10 p-r-16 flex-col flex w-full h-full place-items-start justify-center">
              <div className="pl-4 pr-12 sm:pl-10 sm:pr-16 w-10/12 lg:w-8/12 xl:w-7/12">
                <h1 className="mb-2 truncate text-xl sm:text-lg md:text-2xl line-clamp-1 md:line-clamp-none lg:line-clamp-none lg:text-3xl font-bold text-gray-800">
                  {data.name}
                </h1>
                <p className="truncate text-base leading-6 text-gray-600  line-clamp-1 md:line-clamp-none lg:line-clamp-none">
                  {data.description}
                </p>
                <Link
                  className="hidden sm:inline-block lg:inline-block text-sm leading-6 !no-underline  font-normal mt-6 px-6 py-2 !bg-emerald-500 text-center rounded-md !text-white hover:!bg-emerald-600"
                  to={"/shop"}
                >
                  {t("shopNow", "Shop Now")}
                </Link>
              </div>
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

export default Slider;
